<template>
  <div class="ticket-romancecar mb-foot-2button">
    <!-- ヘッダー -->
    <MFITTHeader headerTitle="座席の選択" />

    <hr />

    <div class="title-block">払いもどす座席を選択してください</div>

    <!-- 予約/購入情報-->
    <div class="content-block">
      <div class="block">
        <!-- 乗車日 -->
        <ViBoardingDate :boardingDate="myLimitedExpressTicket.boarding_date" />

        <!-- 列車名 -->
        <ViTrainInfo
          :name="myLimitedExpressTicket.train.name"
          :carsFormationName="myLimitedExpressTicket.train.cars_formation.name"
        />

        <!-- 区間 -->
        <ViStationSection
          :from="myLimitedExpressTicket.from_station.name"
          :to="myLimitedExpressTicket.to_station.name"
        />

        <!-- 時間 -->
        <ViDepartureAndArrival
          :departure="myLimitedExpressTicket.departure_at"
          :arrival="myLimitedExpressTicket.arrival_at"
        />

        <!-- 座席種類 -->
        <StoreSeatType :selectedSeats="myLimitedExpressTicket.seats"
          :selectedExclusiveCars="myLimitedExpressTicket.train.cars_formation.cars" />
      </div>
    </div>

    <div class="refund-column">
      <div class="checkbox-wrap-vertical">
        <div
          class="row"
          v-for="(seat, index) in myLimitedExpressTicket.seats"
          :key="index"
        >
          <input
            type="checkbox"
            :id="'checkbox-' + index"
            :value="seat"
            v-model="selectedSeats"
          />
          <label class="checkbox" :for="'checkbox-' + index">
            {{ seat.car_number }}号車 {{ seat.display_number }}
            <span v-if="seat.price_division == 'adult'">(おとな)</span>
            <span v-else-if="seat.price_division == 'child'">(こども)</span>
          </label>
        </div>
      </div>
    </div>

    <!-- アクションボタン -->
    <div class="foot-button-block">
      <ItemButton
        :isDisabled="isDisabled"
        :actionType="actionType"
        label="次へ"
        @clicked="goToRefundConfirmationPage"
      />
      <ItemButton
        actionType="btn-cancel"
        label="戻る"
        @clicked="backToPreviousPage"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "TemplateMfittMyTicketRefunc",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const myLimitedExpressTicket = computed(
      () => store.getters["MFITT/myLimitedExpressTicket"]
    );
    const selectedSeats = ref([]);
    const isDisabled = ref(true);
    const actionType = ref("disabled");

    const goToRefundConfirmationPage = async () => {
      store.commit("MFITT/setRefundSeats", selectedSeats);
      router.push({
        name: "MfittMyTicketRefundConfirmation",
        params: { id: route.params.id },
      });
    };

    const backToPreviousPage = () => {
      router.go(-1);
    };

    watchEffect(() => {
      // 座席選択がされたらボタンを押せるように
      if (selectedSeats.value.length > 0) {
        actionType.value = "btn-primary";
        isDisabled.value = false;
      } else {
        actionType.value = "disabled";
        isDisabled.value = true;
      }
    });

    return {
      myLimitedExpressTicket,
      selectedSeats,
      isDisabled,
      actionType,
      goToRefundConfirmationPage,
      backToPreviousPage,
    };
  },
};
</script>

<style>
.title-block {
  margin: 16px 12px 16px;
  font-size: 15px;
  text-align: left;
  line-height: 18px;
  color: #000000;
  font-weight: bold;
}
.ticket-romancecar .content-block {
  width: 100%;
  padding: 0 0 16px;
}
.ticket-romancecar .content-block .block {
  display: table;
  font-size: 13px;
}
.ticket-romancecar .content-block .row {
  display: table-row;
  font-weight: bold;
}
.refund-column {
  margin-bottom: 200px;
}
.checkbox-wrap-vertical {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-flow: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
}
.checkbox-wrap-vertical .row {
  margin: 0.5rem;
  font-size: 15px;
}
.foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 90%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}
</style>
